import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/ui-kit";
import { PageHero } from "@/components/PageHero";
import { NewsletterForm } from "@/components/NewsletterForm";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get("/articles")
      .then((res) => {
        if (active) setArticles(res.data.articles || []);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return (
    <div data-testid="articles-page">
      <Seo
        title="Articles"
        description="Short, honest writing on character, purpose, leadership, and building a meaningful life."
        path="/articles"
        schema={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Employee 2 Employer — Articles",
          url: "https://the-shift-1.preview.emergentagent.com/articles",
        }}
      />
      <PageHero
        eyebrow="Articles & Ideas"
        title="Notes for people building on purpose."
        subtitle="Short, honest writing on character, purpose, leadership, and the long work of building a meaningful life."
        testId="articles-hero"
      />

      <section className="bg-white text-black py-24 lg:py-32">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
          {loading ? (
            <p className="font-body text-black/50 text-center py-12">Loading articles…</p>
          ) : articles.length === 0 ? (
            <p className="font-body text-black/50 text-center py-12">New articles coming soon.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="articles-grid">
              {articles.map((a, i) => (
                <Reveal key={a.id || a.slug} delay={i * 60}>
                  <article
                    data-testid={`article-card-${a.slug}`}
                    className="group border border-[#e5e5e5] p-9 h-full hover:border-[#D4AF37] transition-colors duration-300 cursor-pointer flex flex-col"
                  >
                    <span className="font-body text-xs tracking-[0.2em] uppercase text-[#B8952E]">{a.tag}</span>
                    <h3 className="font-display text-2xl mt-4 leading-snug group-hover:text-[#B8952E] transition-colors">
                      {a.title}
                    </h3>
                    <p className="font-body text-sm text-black/55 mt-4 leading-relaxed flex-1">{a.excerpt}</p>
                    <span className="font-body text-xs text-black/40 mt-6">{a.read_time}</span>
                  </article>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="bg-black noise py-24 lg:py-32">
        <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
          <Eyebrow>Builder Weekly</Eyebrow>
          <h2 className="font-display text-3xl lg:text-4xl text-white mt-6 leading-tight">
            One idea a week to help you build.
          </h2>
          <div className="mt-9 flex justify-center">
            <NewsletterForm sourcePage="articles-newsletter" tags={["Newsletter"]} buttonText="Subscribe" testId="articles-newsletter" />
          </div>
        </div>
      </section>
    </div>
  );
}
